import { ChangeSportModal } from "./ChangeSportModal";
import { DefensiveSubModal } from "./DefensiveSubModal";
import { EditGameStateModal } from "./EditGameStateModal";
import { EndSessionModal } from "./EndSessionModal";
import { LineupSwapModal } from "./LineupSwapModal";
import { QuickTileChangeModal } from "./QuickTileChangeModal";

/**
 * ModalGroup - Renders all tagging modals
 *
 * Modals are controlled by Redux modalState in view slice.
 * Each modal checks if its state matches and renders accordingly.
 *
 * Current modals:
 * - LineupSwapModal: Hitter substitution ("Lineup Swap")
 * - DefensiveSubModal: Pitcher/Catcher substitution ("Pitcher Sub", "Catcher Sub")
 * - EditGameStateModal: Game state editor ("Game State Editor")
 * - QuickTileChangeModal: Quick tile metric change ("Tile Quick Change")
 * - ChangeSportModal: Sport override ("Change Sport")
 * - EndSessionModal: End tagging session confirmation ("End Session")
 */
export const ModalGroup = () => {
  return (
    <>
      <LineupSwapModal />
      <DefensiveSubModal />
      <EditGameStateModal />
      <QuickTileChangeModal />
      <ChangeSportModal />
      <EndSessionModal />
    </>
  );
};
